export default __webpack_public_path__ + "static/media/git.64750bf3.jpg";